<template>
  <v-card
    class="my-3 mx-4"
  >
    <v-layout>
      <v-flex xs2>
        <v-radio
          :value="offer"
          :class="classObj"
        />
      </v-flex>
      <v-flex
        class="my-2"
      >
        <v-layout class="main-text mb-2">
          <v-flex
            xs7 class="terms"
          >
            <div class="subheading mb-2">
              <strong>{{ monthlyPayment(offer.monthly_payment) }}</strong>
            </div>
            <div class="mb-1">
              {{ creditLimit(offer.amount) }}
            </div>
            <div class="mb-1">
              {{ offer.apr }}% APR
            </div>
            <div class="mb-1">
              {{ offer.term_length }}-month term
            </div>
            <div
              v-if="isDeferred"
              class="mb-1"
            >
              Interest deferred {{ offer.intro_duration }} months*
            </div>
          </v-flex>
          <v-flex
            xs5
            class="
              offer-details mr-2
              grey--text text--darken-1
            "
          >
            <div>
              Offer ID {{ offer.offer_id }}
            </div>
          </v-flex>
        </v-layout>
        <div
          v-if="showDetails"
          class="my-2 text-xs-left pr-3"
        >
          *Your Fortiva Credit Line includes the following Special Financing Option:<br/>
          <br/>
          <strong>
            No Interest if Paid in Full within {{ offer.intro_duration }} Months
          </strong>
          <br/>
          <br/>
          Interest will be charged to your account from the purchase date if
          the promotional purchase is not paid in full within the promotional
          period.  Minimum Monthly Payments are required.  Required monthly
          payments may or may not pay off your purchase in full before the end
          of the promotional period.  To avoid paying deferred interest charges,
          you must pay the promotional purchase in full within the promotional
          period.
        </div>
        <div
          v-if="isDeferred"
          style="text-align:left"
        >
          <div
            v-if="!showDetails"
            class="secondary--text"
            @click="switchDetailsStatus"
          >
            *View More
          </div>
          <div
            v-else
            class="secondary--text"
            @click="switchDetailsStatus"
          >
            View Less
          </div>

        </div>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
  export default {
    name: 'OfferCard',
    data () {
      return {
        showDetails: false
      }
    },
    props: {
      offer: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      classObj() {
        return this.$vuetify.breakpoint.smAndUp
          ? 'ma-4'
          : 'mt-4 ml-2'
      },
      isDeferred () {
        return this.offer.intro_duration > 0
      }
    },
    methods: {
      creditLimit (amount) {
        return '$' + amount + ' credit limit'
      },
      monthlyPayment (payment) {
        return `Minimum required monthly is $${payment}`
      },
      switchDetailsStatus () {
        this.showDetails = !this.showDetails
      },
      termAndApr (term, apr) {
        return 'Term length ' + term + ' months, ' + apr + '%' + ' APR'
      }
    }
  }
</script>

<style scoped lang="scss">
  .main-text {
    line-height: 1.35em;
  }

  .terms {
    /*display: flex !important;
    flex-direction: column !important;
    align-items: flex-start !important;*/
    text-align: left;
  }

  .offer-details {
    text-align: right;
  }
</style>
